import {ConstantsParser} from "../../../ConstantsParser";
import {StylesParser} from "../../../StylesParser";

export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      hasIcon: false,
      hasText: false,
      text: "Example Text",
      class: 'fas',
      icon: 'fa-cube'
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    let styles = (new StylesParser(this.styles())).parse()
    styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')
    return `<div
        class="${classes}"
        style="${styles}"
     >Lineal</div>`;
  }

  classes() {
    return [
      {property: 'Width', value: 'WIDTH_AUTO'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
    ]
  }

  styles() {
    return [
      {property:'BorderColor', styleProperty: 'border-color', value: 'rgba(138.24,115.2,115.2, 1)'}
    ]
  }

  iconStyles() {
    return [
      { property: 'TextColor', styleProperty: 'color', value: 'rgb(87,88,88, 1)'}
    ]
  }

  iconContainerClasses() {
    return []
  }

  iconContainerStyles() {
    return []
  }

  iconClasses() {
    return []
  }

  textClasses() {
    return [
      {property: 'FontWeight', value: 'NORMAL'},
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
    ]
  }

  textStyles() {
    return []
  }

  contentClasses() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
    ]
  }

  containerClasses() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'AlignItems', 'value': 'ALIGN_ITEMS_CENTER'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses(),
      },
      contentClasses: {
        desktop: this.contentClasses(),
        tablet: this.contentClasses(),
        phone: this.contentClasses(),
      },
      iconContainerClasses: {
        desktop: this.iconContainerClasses(),
        tablet: this.iconContainerClasses(),
        phone: this.iconContainerClasses(),
      },
      iconClasses: {
        desktop: this.iconClasses(),
        tablet: this.iconClasses(),
        phone: this.iconClasses(),
      },
      iconContainerStyles: {
        desktop: this.iconContainerStyles(),
        tablet: this.iconContainerStyles(),
        phone: this.iconContainerStyles()
      },
      textClasses: {
        desktop: this.textClasses(),
        tablet: this.textClasses(),
        phone: this.textClasses()
      },
      textStyles: {
        desktop: this.textStyles(),
        tablet: this.textStyles(),
        phone: this.textStyles()
      },
    }
  }
}
